<template>
  <div>
    <div class="route-view" v-for="t in item.transports" :key="t.id">
      <div class="ops">{{ t.operations.map((o) => o.name).join("/") }}</div>
      <div class="name">{{ (t.trucker || {})["name"] }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order-status-truckers",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
